import {
  ChakraProvider,
  extendTheme,
  Fade
} from "@chakra-ui/react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { HomePage } from "./components/home-page/home.page"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.100',
        color: 'black',
      },
    },
  },
  colors: {
    brand: {
      50: "83E9AF",
      100: "#7EE1A9",
      200: "#79D7A1",
      300: "#65B687",
      500: "#559A73",
      700: "#487F5F",
      900: "#345B45"
    }
  }
})

// Create a client instance outside the component
const queryClient = new QueryClient();

export const App = () => (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme} >
        <Fade in>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
            </Routes>
          </BrowserRouter>
        </Fade>
      </ChakraProvider>
    </QueryClientProvider>
)
